module.exports = __webpack_public_path__ + "static/media/social-security-vs-70.a8a5d950.svg";